import React, {useEffect, Component, useState} from 'react'
import history from "../../route/history";

const notity = () => {
	const prePage = (e) => {
		e.preventDefault();
		history.goBack();
	  }

	return(
		<React.Fragment>
			<div id="contents">	
				<div className="content-header type2">
					<a href="#" className="page-prev" onClick={prePage}>뒤로이동</a>
					<h2>알람함</h2>
					<div className="breadcrumb">
						<span>Home</span><em>알람함</em>
					</div>
				</div>

				<div className="alarm-wrap">
					<p className="txt">※ 최근 3개월 이내 알림 내역만 확인하실 수 있습니다.</p>
					<ul className="alarm-list">
						<li className="nodata">
							알림 내역이 없습니다.
						</li>
						<li className="unconfirmed">
							<a href="#">
								<dl>
									<dt>(문서명)이 발급되었습니다.</dt>
									<dd>2022.00.00</dd>
								</dl>
							</a>
						</li>
						<li className="unconfirmed">
							<a href="#">
								<dl>
									<dt>1회 열람용 (문서명)을 수취 확인하였습니다.</dt>
									<dd>2022.00.00</dd>
								</dl>
							</a>
						</li>
						<li>
							<a href="#">
								<dl>
									<dt>(문서명)이 접수되었습니다.</dt>
									<dd>2022.00.00</dd>
								</dl>
							</a>
						</li>
						<li>
							<a href="#">
								<dl>
									<dt>1회 열람용 (문서명)을 수취 확인하였습니다.</dt>
									<dd>2022.00.00</dd>
								</dl>
							</a>
						</li>
						<li>
							<a href="#">
								<dl>
									<dt>(문서명)이 접수되었습니다.</dt>
									<dd>2022.00.00</dd>
								</dl>
							</a>
						</li>
						<li>
							<a href="#">
								<dl>
									<dt>KINET 김전자 님께 보낸 FTA 원산지 증명서 서비스를 수취반려하였습니다.</dt>
									<dd>2022.00.00</dd>
								</dl>
							</a>
						</li>
					</ul>
				</div>
			</div>
		</React.Fragment>
	)
}
export default notity